import React from 'react';
import styled from 'styled-components';
import ButtonGrupo from '../../atoms/ButtonGrupo';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 33px;
  margin-bottom: 33px;
`;

export default function GrupoSeguros({ onAlterarSeguroSelecionado, gruposSeguros = [] }) {
  return (
    <Container>
      {gruposSeguros.map((grupo) => (
        <ButtonGrupo
          id={`btn-${grupo.id}`}
          key={grupo.id}
          icon={grupo.imgOn}
          iconAlt={grupo.tag}
          grupo={grupo.tag}
          onClick={() => onAlterarSeguroSelecionado(grupo)}
        />
      ))}
    </Container>
  );
}
